export default __webpack_public_path__ + "static/media/banner-22-FR.59bd88fe.png";